/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo, useRef } from 'react'
import { useDrag } from '@use-gesture/react'
import { useThree } from '@react-three/fiber'
import { useDispatch } from 'react-redux'
import debounce from 'lodash.debounce';

import * as actionCreator from '../../../../action/index';

import { params, const_var } from '../../../../redux/reducers/reducer';

import Wall from './Wall';
import Roof from './Roof';
import Legs from './Legs';
import OutLineSection from '../LeftLean/OutLineSection';
import DoorWindows from './DoorWindows';
import WallName from './WallName';
import LeftLeanToMeasurement from '../../Measurements/LeanToMeasurement/LeftLeanToMeasurement';
import { controls } from '../../../../redux/reducers/eventReducer';

const LeftLean = ({ overlapTrussArr, setOverlapTrussArr, normalMap, envMap }) => {
    const ref = useRef();
    const get = useThree((state) => state.get)
    const dispatch = useDispatch();
    const [isDragable, setIsDragable] = useState(true);
    const [position, setPosition] = useState(params.lean_p_pos);
    const [startPosition, setStartPosition] = useState(params.lean_p_pos);
    const [isLeftLeanDragging, setIsLeftLeanDragging] = useState(false);
    const [dragging, setDragging] = useState(false);
    const [isHovered, setIsHovered] = useState(false)
    const [rightWrapSize, setRightWrapSize] = useState(0)
    const [leftWrapSize, setLeftWrapSize] = useState(0)
    const [overHangWidth, setOverHangWidth] = useState(0);
    const [overHangLength, setOverHangLength] = useState(0);
    const [offSetRoofTrussH, setOffSetRoofTrussH] = useState(0)
    const [offSetRoofTrussV, setOffSetRoofTrussV] = useState(0)
    const [leanToTrussPosArr, setLeanToTrussPosArr] = useState([])
    const [previousLenght, setPreviousLenght] = useState(0)

    const prvLean_p_d = useMemo(() => {
        const prvLean_p_d = ref.current
        ref.current = params.lean_p_d;
        
        return prvLean_p_d    
    }, [params.lean_p_d])

    const camPosX = const_var.camera?.position?.x;

    let offset = 1
    if(camPosX >= 0) offset = 1;
    else if(camPosX < 0) offset = -1;

    const limit = useMemo(() => {
        return {
            min: -params.p_d / 2 + params.lean_p_d / 2,
            max: params.p_d / 2 - params.lean_p_d / 2
        }
    }, [params.p_d, params.lean_p_d])
    const bind = useDrag(
        ({ down, delta, first, event, movement: [mx, my] }) => {
            if (controls.isCheckActiveTab === 'doorwindow' ? (const_var.focusedSection === "leftlean" && params.activeWall !== "L_L_F_S_W") : true) {
                event.stopPropagation();
            }

            if (controls.isCheckActiveTab === 'leantos' && !params.add_left_back_lean_porch && !params.add_left_front_lean_porch) {
                if (first) {
                    setStartPosition(position);
                }

                if (down === true) {
                    const distance = (const_var.controls!=undefined && const_var.controls.getDistance!=undefined)?const_var.controls.getDistance([0, 0, 0]):[0, 0, 0];
                    const_var.controls.enableRotate = false;
                    get().gl.domElement.style.cursor = 'move';
                    
                    let distanceValue = distance - params.p_d / 2;

                    if (isDragable) {
                        const nextPosition = startPosition + (-mx * offset) * (distanceValue / 1000);
                        if (nextPosition < limit.min) {
                            setPosition(limit.min)
                        } else if (nextPosition > limit.max) {
                            setPosition(limit.max)
                        } else {
                            setPosition(nextPosition);
                        } 
                        setDragging(true)
                    }
                } else {
                    const_var.controls.enableRotate = true;
                    get().gl.domElement.style.cursor = 'auto'

                    dispatch(actionCreator.changeLeanDragState(true));
                    setIsLeftLeanDragging(true);
                    setIsDragable(false);

                    // const sideArrayLeft = const_var.newDoorsArray.filter((item) => item.userData.wallName === 'L_L_L_W' || item.userData.wallName === 'L_L_L_S_W');
                    // sideArrayLeft.map((item) => {
                    //     dispatch(actionCreator.updateDoorWindowPosition(item.uniqueId, item.positionX + (position - startPosition)));
                    // })

                    // const sideArrayRight = const_var.newDoorsArray.filter((item) => item.userData.wallName === 'L_L_R_S_W');
                    // sideArrayRight.map((item) => {
                    //     dispatch(actionCreator.updateDoorWindowPosition(item.uniqueId, item.positionX - (position - startPosition)));
                    // })

                    const updatedNewDoorArr = const_var.newDoorsArray.map((item) => {
                        if (item.userData.wallName === 'L_L_L_W' || item.userData.wallName === 'L_L_L_S_W' || item.userData.wallName === 'L_L_R_S_W') {
                            return {
                                ...item,
                                positionX: item.userData.wallName === 'L_L_R_S_W' ? item.positionX - (position - startPosition) : item.positionX + (position - startPosition),
                                minLimitX: item.minLimitX + (position - startPosition),
                                maxLimitX: item.maxLimitX + (position - startPosition)
                            }
                        }
                        return item;
                    })
                    if (JSON.stringify(const_var.newDoorsArray) !== JSON.stringify(updatedNewDoorArr)) {
                        dispatch(actionCreator.updateDoorWindowsArray(updatedNewDoorArr, true));
                    }

                    dispatch(actionCreator.updateLeanToPosition('left', position))
                    if (position === limit.min) {
                        dispatch(actionCreator.changeLeantoPosition({event: 3, value: 'left'}))
                    } else if (position === limit.max) {
                        dispatch(actionCreator.changeLeantoPosition({event: 2, value: 'left'}))
                    } else if (position === 0) {
                        dispatch(actionCreator.changeLeantoPosition({event: 1, value: 'left'}))
                    } else {
                        dispatch(actionCreator.changeLeantoPosition({event: 4, value: 'left'}))
                    }

                    setPreviousLenght(`${params.p_d}${params.lean_p_d}`)
                    setStartPosition(position);
                    setDragging(false)

                    if(position !== startPosition && !dragging){
                        setPosition(startPosition)
                    } else {
                        setPosition(position)
                    }

                    debounceForDragLean()
                }
            }
        },
        { pointerEvents: true }
    );

    const debounceForDragLean = debounce(() => {
        setTimeout(() => {
            setIsDragable(true)
            clearTimeout();
        }, [250])
    }, [250])

    useMemo(() => {
        let pos = 0;

        if( Number(params.leantoAlignmentLeft) === 1 ) pos = 0;
        else if( Number(params.leantoAlignmentLeft) === 2 ) pos = params.p_d / 2 - params.lean_p_d / 2;
        else if( Number(params.leantoAlignmentLeft) === 3 ) pos = -params.p_d / 2 + params.lean_p_d / 2;
        else if( Number(params.leantoAlignmentLeft) === 4 && previousLenght != `${params.p_d}${params.lean_p_d}` && !params.apiCallAfterEdit){ pos = 0; dispatch(actionCreator.changeLeantoPosition({event: 1, value: 'left'}))}
        else pos = position;
        
        if(!isLeftLeanDragging || params.add_left_lean) {
            let sideArrayLeft;
            // if( Number(params.leantoAlignmentLeft) === 2 || Number(params.leantoAlignmentLeft) === 3){
            //     sideArrayLeft = const_var.newDoorsArray.filter((item) => item.userData.wallName === 'L_L_L_S_W');
            // } else {
                sideArrayLeft = const_var.newDoorsArray.filter((item) => item.userData.wallName === 'L_L_L_W' || item.userData.wallName === 'L_L_L_S_W');
            // }

            sideArrayLeft.map((item) => {
                dispatch(actionCreator.updateDoorWindowPosition(item.uniqueId, item.positionX + (pos - startPosition)));
            })

            const sideArrayRight = const_var.newDoorsArray.filter((item) => item.userData.wallName === 'L_L_R_S_W');
            sideArrayRight.map((item) => {
                dispatch(actionCreator.updateDoorWindowPosition(item.uniqueId, item.positionX - (pos - startPosition)));
            })

            // const updatedNewDoorArr = const_var.newDoorsArray.map((item) => {
            //     if (item.userData.wallName === 'L_L_L_W' || item.userData.wallName === 'L_L_L_S_W' || item.userData.wallName === 'L_L_R_S_W') {
            //         return {
            //             ...item,
            //             positionX: item.userData.wallName === 'L_L_R_S_W' ? item.positionX - (pos - startPosition) : item.positionX + (pos - startPosition)
            //         }
            //     }
            //     return item;
            // })
            // if (JSON.stringify(const_var.newDoorsArray) !== JSON.stringify(updatedNewDoorArr)) {
            //     dispatch(actionCreator.updateDoorWindowsArray(updatedNewDoorArr, true));
            // }

            setStartPosition(pos);
            setPosition(pos);
            if(!params.apiCallAfterEdit) dispatch(actionCreator.updateLeanToPosition('left', pos))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Number(params.leantoAlignmentLeft), params.lean_p_d, params.add_left_lean, params.add_left_front_lean_porch, params.add_left_back_lean_porch, params.p_d, params.lean_p_pos])
    
    useMemo(() => {
        if (params.add_left_lean && (!params.add_left_front_lean_porch || !params.add_left_back_lean_porch)) {
            dispatch(actionCreator.changeLeanDragState(true));   
            setIsLeftLeanDragging(true);   
        } else {
            setIsLeftLeanDragging(false);   
        }
    }, [Number(params.leantoAlignmentLeft), params.add_left_lean, params.add_left_front_lean_porch, params.add_left_back_lean_porch])

    useMemo(() => {
        dispatch(actionCreator.changeLeanDragState(false));
        setIsLeftLeanDragging(false)
        setPosition(params.lean_p_pos)
    }, [params.lean_p_pos, Number(params.leantoAlignmentLeft)])
    
    useMemo(() => {
        if(params.add_left_back_lean_porch || (params.add_left_back_lean_porch && params.add_left_front_lean_porch)){
            setRightWrapSize(params.leanB_p_w)
        } else {
            setRightWrapSize(0)
        }
    }, [params.add_left_back_lean_porch, params.add_left_front_lean_porch, params.leanB_p_w])

    useMemo(() => {
        if(params.add_left_front_lean_porch || (params.add_left_back_lean_porch && params.add_left_front_lean_porch)){
            setLeftWrapSize(params.leanF_p_w)
        } else {
            setLeftWrapSize(0)
        }
    }, [params.add_left_front_lean_porch, params.add_left_back_lean_porch, params.leanF_p_w])

    useMemo(() => {
        const offset = 0.15;
        if (params.p_r_s === 1) {
            setOverHangWidth(0.8 + offset)
            setOverHangLength(0.15 + offset)
            setOffSetRoofTrussH(0.3)
            setOffSetRoofTrussV(0.6)
        } else if (params.p_r_s === 2) {
            setOverHangWidth(0.7 + offset)
            setOverHangLength(0.3 + offset)
            setOffSetRoofTrussH(0.4)
            setOffSetRoofTrussV(0.25)
        } else if (params.p_r_s === 3) {
            setOverHangWidth(0.7 + offset)
            setOverHangLength(0.5 + offset)
            setOffSetRoofTrussH(0.4)
            setOffSetRoofTrussV(0.25)
        }

        if (params.p_r_s !== 1) {
            if (params.o_v_h_n_g) {
                setOverHangLength(prev => prev + 0.7)
            } else {
            }
            if (params.o_v_h_n_g_e) {
                setOverHangWidth(prev => prev + 0.2)
            } else {
            }
        }
    }, [params.p_r_s, params.o_v_h_n_g_e, params.o_v_h_n_g])

    useMemo(() => {
        if(params.add_left_lean) {
            dispatch(actionCreator.setLeanToTrussPosInfo({
                data: { leftLeanTo: leanToTrussPosArr }
            }));
        } else {
            dispatch(actionCreator.setLeanToTrussPosInfo({
                data: { leftLeanTo: [] }
            }));
        }
        
    }, [leanToTrussPosArr, params.add_left_lean, params.add_left_front_lean_porch, params.add_left_back_lean_porch ])
   
    useMemo(() => {
        const_var.newDoorsArray.filter((e) => e.userData.wallName === 'L_L_L_S_W' || e.userData.wallName === 'L_L_R_S_W').map((item) => {
            let newPositionX;
            if(item.userData.wallName === 'L_L_L_S_W'){
                newPositionX = item.positionX + (prvLean_p_d - params.lean_p_d) / 2;
            } else {
                newPositionX = item.positionX - (prvLean_p_d - params.lean_p_d) / 2;
            }
            dispatch(actionCreator.updateDoorWindowPosition(item.uniqueId, newPositionX))
        });

    }, [params.lean_p_d, prvLean_p_d])
    
    return params.add_left_lean && (        
        <group 
            name='leftlean' 
            position={[0,0,position]}
            {...bind()}
            
            onPointerOver={(e) => {
                if ((controls.isCheckActiveTab === 'leantos') && const_var.controls.enableRotate) setIsHovered(true)}
            }
            onPointerOut={() => setIsHovered(false)}
        >
            <group name='need-translucent-group'>
                { (params.p_b_c_b_l != "Open" || params.p_b_c_b_l_f != "Open" || params.p_b_c_b_l_b != "Open" || params.add_storage_check) && <Wall />}
                <Roof />
            </group>
            <Legs overlapTrussArr={overlapTrussArr} normalMap={normalMap} envMap={envMap} setLeanToTrussPosArr={setLeanToTrussPosArr} />
            
            <group position={dragging ? undefined : [0, 0, -position]}>
                <DoorWindows overlapTrussArr={overlapTrussArr} setOverlapTrussArr={setOverlapTrussArr} />
            </group>

            {const_var.callMesure && 
                <>
                    <WallName />
                    <group name='Measurements-leftLeanto'><LeftLeanToMeasurement color='#2F7CBF' /></group>
                </>
            }
            {(isHovered || dragging) && controls.isCheckActiveTab === 'leantos' && <OutLineSection leftWrapSize={leftWrapSize} rightWrapSize={rightWrapSize} overHangWidth={overHangWidth} overHangLength={overHangLength} offSetRoofTrussH={offSetRoofTrussH} offSetRoofTrussV={offSetRoofTrussV}/>}
        </group>
    )
}

export default LeftLean